/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PendingUser
 */
export interface PendingUser {
    /**
     * 
     * @type {string}
     * @memberof PendingUser
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PendingUser
     */
    userEmail: string;
    /**
     * 
     * @type {string}
     * @memberof PendingUser
     */
    role: string;
    /**
     * 
     * @type {string}
     * @memberof PendingUser
     */
    status: string;
}

/**
 * Check if a given object implements the PendingUser interface.
 */
export function instanceOfPendingUser(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "userEmail" in value;
    isInstance = isInstance && "role" in value;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function PendingUserFromJSON(json: any): PendingUser {
    return PendingUserFromJSONTyped(json, false);
}

export function PendingUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): PendingUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'userEmail': json['userEmail'],
        'role': json['role'],
        'status': json['status'],
    };
}

export function PendingUserToJSON(value?: PendingUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'userEmail': value.userEmail,
        'role': value.role,
        'status': value.status,
    };
}

